"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToastText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const StyledToastText = styled_components_1.default.p `
  margin-left: 5px;
`;
exports.StyledToastText = StyledToastText;
